import { omit } from "lodash";
import useSWR from "swr";

import { Currency } from "@zapier/currency";
import { Currency as CurrencyRest } from "@zapier/currency/esm/rest-types";

import { fetcher } from "../../utils/fetcher";

export const defaultCurrency = {
  icon: "UnitedStates",
  id: "USD",
  multiplier: 1,
  name: "USD",
  symbol: "$",
  zeroDecimal: false,
};

type CurrenciesRates = {
  objects: CurrencyRest[];
  selectedCurrency?: Currency;
};

export const useCurrencies = () => {
  const { data, mutate, error, isLoading } = useSWR<CurrenciesRates>(
    `/api/v4/currencies/rates`,
    fetcher
  );

  let currencies: Currency[] = [];

  if (data?.objects) {
    currencies = data.objects.map((currency: CurrencyRest) => ({
      ...omit(currency, ["zero_decimal"]),
      zeroDecimal: currency.zero_decimal,
    }));
  }

  return {
    currencies: currencies || [],
    error: error
      ? "There was an issue loading currencies. Please try again"
      : null,
    isLoading,
    onSelectCurrency: (currency: Currency) => {
      mutate(
        {
          ...(data as CurrenciesRates),
          selectedCurrency: currency,
        },
        false
      );
    },
  };
};
